import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "shouldCloseOnClickOutside", "renderModal", "onClose", "isScrollable"];
import React, { useRef, useState } from 'react';
import { describe, PropTypes } from '@amzn/stencil-react-desc';
import { pickDataProps, withTestAttributes } from "../utils";
import Modal from "./Modal";
import { MODAL_TITLE_ID } from "./constants";
import { jsx as ___EmotionJSX } from "@emotion/core";

var WithModalWithoutDocs = function WithModalWithoutDocs(_ref) {
  var children = _ref.children,
      shouldCloseOnClickOutside = _ref.shouldCloseOnClickOutside,
      renderModal = _ref.renderModal,
      onClose = _ref.onClose,
      isScrollable = _ref.isScrollable,
      forwardedProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var open = function open() {
    setIsOpen(true);
  };

  var close = function close() {
    setIsOpen(false);
  }; // This is separate because it is only passed to the <Modal> itself. Whenever
  // `close` is passed to a render function, it must not include the onClose()
  // call otherwise the callback will be called twice - once when the consumer
  // calls close() and once when the focus trap deactivates.


  var closeWithCallback = function closeWithCallback() {
    close();
    !!onClose && onClose();
  };

  var ref = useRef(null);
  return ___EmotionJSX(React.Fragment, null, children({
    open: open,
    close: close,
    isOpen: isOpen
  }), ___EmotionJSX(Modal, _extends({}, pickDataProps(forwardedProps), {
    ref: ref,
    isOpen: isOpen,
    close: closeWithCallback,
    shouldCloseOnClickOutside: shouldCloseOnClickOutside,
    "aria-labelledby": MODAL_TITLE_ID,
    isScrollable: isScrollable
  }), renderModal({
    close: close,
    ref: ref
  })));
};

var WithModalWithDocs = describe(WithModalWithoutDocs).description('FAC component for displaying a modal.');
WithModalWithDocs.propTypes = {
  children: PropTypes.func.isRequired.description('Render function used to trigger modals.').format("({\n  open: () => void,\n  close: () => void,\n  isOpen: boolean\n}) => React.ReactNode\n  "),
  renderModal: PropTypes.func.isRequired.description('Render function to render the content of the modal.').format("({\n  close: () => void,\n  ref: node\n}) => React.ReactNode"),
  shouldCloseOnClickOutside: PropTypes.bool.description('Whether the modal can be closed by clicking outside of it.'),
  onClose: PropTypes.func.description('Callback called when the modal is closed.').format('() => void'),
  isScrollable: PropTypes.bool.description('Toggles whether the modal is scrollable.')
};
var WithModal = withTestAttributes({})(WithModalWithDocs);
WithModal.displayName = 'WithModal';
export default WithModal;